export const FETCH_START = 'FETCH_START'
export const FETCH_COMPLETE = 'FETCH_COMPLETE'
export const FETCH_ERROR = 'FETCH_ERROR'
